function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "noun_Incognito_7572",
  transform: "translate(0 -5.397)"
}, React.createElement("path", {
  id: "Path_1112",
  "data-name": "Path 1112",
  d: "M94.543,48.617H78S119.75,31.545,75.371,22.46c-.027.022-2.246-.353-2.246-.353S70.5,12.539,70.5,11.67c0-2.983-3.95-5.75-7.047-6.068a9.381,9.381,0,0,0-4.223.056,47.5,47.5,0,0,1-6.462,1.229c-4.178.416-8.778.356-12.433.765a5.99,5.99,0,0,0-4.378,2.372c-.4.51-8.508,15.088-9.957,17.146a26.735,26.735,0,0,1,.188-3.332S-12.666,34.38,18.022,48.617C18,48.463,0,48.758,0,48.758L17.6,72.834s-4.475,4.961-6.475,7.461-6.338,12.25-6.338,12.25H92.924S89.9,78.335,82.786,70.3c-.169-.191-6.064,2.917-6.007,2.628C76.827,72.695,94.543,48.617,94.543,48.617ZM50.967,63.166c-7.978.938-10.4-1.4-12.092-4.5a10.951,10.951,0,0,1-9.965,2.056c-5.351-1.783-7.737-10.245-6.477-9.861,5.948,1.81,23.519,5.61,36.694,3.1C61.988,53.416,58.945,62.229,50.967,63.166Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_1113",
  "data-name": "Path 1113",
  d: "M80.426,67.639",
  fill: "#fff"
}));

var SvgMysteryGuestIconWhite = function SvgMysteryGuestIconWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 95.8,
    height: 87.148,
    viewBox: "0 0 95.8 87.148",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMysteryGuestIconWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mystery_guest_icon_white.662e744b.svg";
export { ForwardRef as ReactComponent };